var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.359,
    height: 21.658,
    viewBox: "0 0 24.359 21.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-leaf",
    "data-name": "Icon awesome-leaf",
    d: "M23.1.41a.658.658,0,0,0-1.2-.051,7.253,7.253,0,0,1-6.34,3.7H12.182A8.123,8.123,0,0,0,4.062,12.18a8.363,8.363,0,0,0,.063.867A20.235,20.235,0,0,1,16.243,9.473a.677.677,0,1,1,0,1.353C5.61,10.827,1.1,17.344.1,19.793a1.355,1.355,0,0,0,2.508,1.028,11.127,11.127,0,0,1,3.041-3.832,8.1,8.1,0,0,0,7.4,3.265c6.64-.482,11.314-6.437,11.314-13.729A15.38,15.38,0,0,0,23.1.41Z",
    transform: "translate(-0.004 0.002)",
    fill: "#64b22f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.537c72d8becfb5d7ed0ba5a828850c69.svg";
export { ForwardRef as ReactComponent };